export default {
      id: "color_locker-usage",
      viewBox: "0 0 27.3 38.3",
      url: __webpack_public_path__ + "sprite.svg#color_locker",
      toString: function () {
        return this.url;
      }
    }